'use strict';

module.exports = require('./node/');



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/platform/index.js
// module id = 249
// module chunks = 0